import { render, staticRenderFns } from "./BannerSantander.vue?vue&type=template&id=796f2ab7&scoped=true"
import script from "./BannerSantander.vue?vue&type=script&lang=js"
export * from "./BannerSantander.vue?vue&type=script&lang=js"
import style0 from "./BannerSantander.vue?vue&type=style&index=0&id=796f2ab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f2ab7",
  null
  
)

export default component.exports